import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../motion";
import { SERVICE_META } from "../../data/content";
import { useLang } from "../../i18n";

const SPANS = [
    "md:col-span-4", "md:col-span-2",
    "md:col-span-3", "md:col-span-3",
    "md:col-span-2", "md:col-span-4",
    "md:col-span-3", "md:col-span-3",
];

const ServiceCard = ({ meta, data, span, i }) => {
    const Icon = meta.icon;
    return (
        <Reveal delay={(i % 3) * 0.08} className={span}>
            <Link
                to={`/servicios/${meta.slug}`}
                data-testid={`service-card-${meta.slug}`}
                className="group flex h-full flex-col overflow-hidden rounded-[1.75rem] border border-[#E3DCCF] bg-white shadow-sm transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:border-terracotta/40 hover:shadow-xl"
            >
                <div className="relative h-44 overflow-hidden sm:h-48">
                    <img
                        src={meta.img}
                        alt={data.nombre}
                        loading="lazy"
                        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                    <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-cream/95 px-3 py-1.5 text-[11px] font-bold text-olive-dark backdrop-blur">
                        <Icon size={13} />
                        {data.tagline}
                    </span>
                </div>
                <div className="flex flex-1 flex-col p-6">
                    <h3 className="font-serif text-xl font-semibold text-ink transition-colors duration-200 group-hover:text-terracotta sm:text-2xl">
                        {data.nombre}
                    </h3>
                    <p className="mt-2 flex-1 text-sm leading-relaxed text-[#525B53]">{data.desc}</p>
                    <div className="mt-5 flex items-center justify-between">
                        <span className={`text-xs font-bold uppercase tracking-wider ${data.tarifas ? "text-terracotta" : "text-[#7C877E]"}`}>
                            {data.chip}
                        </span>
                        <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#E3DCCF] text-ink transition-[background-color,color,border-color] duration-200 group-hover:border-terracotta group-hover:bg-terracotta group-hover:text-cream">
                            <ArrowUpRight size={16} />
                        </span>
                    </div>
                </div>
            </Link>
        </Reveal>
    );
};

const ServicesGrid = () => {
    const { t } = useLang();
    return (
        <div data-testid="services-grid" className="mt-12 grid gap-5 sm:grid-cols-2 md:grid-cols-6">
            {SERVICE_META.map((meta, i) => (
                <ServiceCard key={meta.slug} meta={meta} data={t.services[meta.slug]} span={SPANS[i % SPANS.length]} i={i} />
            ))}
        </div>
    );
};

export default ServicesGrid;
